module.exports = __webpack_public_path__ + "img/clipboard-icon.77a8f287.svg";